module.exports = __webpack_public_path__ + "img/合肥办公室.ebf7f703.png";